import React from 'react';
const Footer = () => {
  return <footer className="w-full py-8 px-6 md:px-12 lg:px-24 bg-[#6B5A45] text-white" data-id="element-62">
      <div className="max-w-6xl mx-auto" data-id="element-63">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-64">
          <div data-id="element-65">
            <div className="text-xl font-bold" data-id="element-66">RecetasExpress</div>
            <p className="text-sm opacity-80" data-id="element-67">
              © 2025 Todos los derechos reservados
            </p>
          </div>
          <div className="flex space-x-6" data-id="element-68">
            <a href="#" className="hover:underline" data-id="element-69">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:underline" data-id="element-70">
              Política de Privacidad
            </a>
            <a href="#" className="hover:underline" data-id="element-71">
              Contacto
            </a>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;